import { render, staticRenderFns } from "./TemplateInheritanceChangingModal.vue?vue&type=template&id=2867a5ba&scoped=true&"
import script from "./TemplateInheritanceChangingModal.vue?vue&type=script&lang=ts&"
export * from "./TemplateInheritanceChangingModal.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateInheritanceChangingModal.vue?vue&type=style&index=0&id=2867a5ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867a5ba",
  null
  
)

export default component.exports